@if (hasReports()) {
<div class="recent-reports section-margin-sm" [class]="'variant-' + colorVariant">
  <div class="reports-header">
    <span class="header-title head-medium text-secondary section-margin-s">{{ 'recentReports.title' | t }}</span>
    @if (hasMoreReports()) {
    <button class="toggle-btn sub" (click)="toggleShowAll()">
      {{ showAll() ? ('recentReports.showLess' | t) : ('recentReports.showAll' | t) + ' (' + totalReports() + ')' }}
    </button>
    }
  </div>

  <div class="reports-list">
    @for (report of visibleReports(); track report.id) {
    <div class="report-item">
      <div class="report-main">
        <div class="report-types">
          @for (rt of report.reportTypes; track rt; let last = $last) {
          <span class="report-type-entry">
            <img class="report-type-icon icon-text-secondary" [src]="getReportTypeIcon(rt)" [alt]="getReportTypeLabel(rt)">
            <span class="report-type-label b-medium">{{ getReportTypeLabel(rt) }}</span>
            @if (!last) {
            <span class="report-type-separator"> </span>
            }
          </span>
          }
        </div>
        <div class="report-meta-container">
          @if (report.userName) {
          <span class="report-user b-medium text-secondary notranslate" translate="no">{{ report.userName }}</span>
          }
          <span class="report-meta b text-tertiary">
            {{ getTimeAgo(report) }}
          </span>
        </div>
      </div>
      @if (report.upvotes > 0 || report.downvotes > 0) {
      <div class="report-votes" [class]="getVoteClass(report)">
        <span class="vote-count sub-semibold">
          @if (getNetVotes(report) > 0) { +{{ getNetVotes(report) }} }
          @else if (getNetVotes(report) < 0) { {{ getNetVotes(report) }} }
          @else { 0 }
        </span>
      </div>
      }
    </div>
    }
  </div>
</div>
}
